module.exports = __webpack_public_path__ + "img/fog_2.b26a32e4.png";